import script from "./LocaleMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleMenu.vue?vue&type=script&setup=true&lang=js"

import "./LocaleMenu.vue?vue&type=style&index=0&id=275b5f4b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275b5f4b"]])

export default __exports__